module.exports = __webpack_public_path__ + "img/make_mobile_01.0e884972.png";